var map = {
	"./azb0.jpg": "fTqk",
	"./azb1.jpg": "k7nl",
	"./azb2.jpg": "qDDN",
	"./azb3.jpg": "8Vts"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VYmj";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto ^\.\/azb.*\.jpg$
// module id = VYmj
// module chunks = 1